import { useEffect } from 'react';
import Hero from './components/Hero';
import ApartmentFeatures from './components/ApartmentFeatures';
import PreLaunchTable from './components/PreLaunchTable';
import Amenities from './components/Amenities';
import LocationBenefits from './components/LocationBenefits';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';

export default function Home() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

    const schemaData = [
      {
        '@context': 'https://schema.org',
        '@type': 'RealEstateListing',
        name: 'Lançamento Imobiliário Exclusivo em Linhares',
        description:
          'Pré-lançamento exclusivo em Linhares-ES: apartamentos de 2 e 3 quartos a partir de 74m², 15 andares, 4 apartamentos por andar, lazer na cobertura com piscina adulto e infantil, bar molhado, salão de festas e salão de jogos. Reserve sua unidade com fluxo de pagamento flexível.',
        url: siteUrl,
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Linhares',
          addressRegion: 'ES',
          addressCountry: 'BR',
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: -19.3914,
          longitude: -40.0631,
        },
        numberOfRooms: '2 a 3 quartos',
        floorSize: {
          '@type': 'QuantitativeValue',
          minValue: 74,
          unitCode: 'MTK',
        },
        amenityFeature: [
          { '@type': 'LocationFeatureSpecification', name: 'Piscina Adulto', value: true },
          { '@type': 'LocationFeatureSpecification', name: 'Piscina Infantil', value: true },
          { '@type': 'LocationFeatureSpecification', name: 'Bar Molhado', value: true },
          { '@type': 'LocationFeatureSpecification', name: 'Salão de Festas', value: true },
          { '@type': 'LocationFeatureSpecification', name: 'Salão de Jogos', value: true },
          { '@type': 'LocationFeatureSpecification', name: 'Lazer na Cobertura', value: true },
        ],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'Lançamento Imobiliário Linhares | Apartamentos Pré-Lançamento 2 e 3 Quartos',
        description:
          'Pré-lançamento exclusivo em Linhares-ES: apartamentos de 2 e 3 quartos a partir de 74m², lazer na cobertura. Reserve com pagamento flexível na localização que mais valoriza imóveis em Linhares.',
        url: siteUrl,
        inLanguage: 'pt-BR',
        isPartOf: {
          '@type': 'WebSite',
          url: siteUrl,
          name: 'Lançamento Imobiliário Linhares',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'Quais são os tipos de apartamentos disponíveis no lançamento imobiliário em Linhares?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'O empreendimento oferece apartamentos de 2 e 3 quartos, a partir de 74m², distribuídos em 15 andares com 4 unidades por andar.',
            },
          },
          {
            '@type': 'Question',
            name: 'Quais são as opções de lazer do empreendimento em Linhares?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'O edifício conta com lazer completo na cobertura: piscina adulto e infantil, bar molhado, salão de festas e salão de jogos.',
            },
          },
          {
            '@type': 'Question',
            name: 'Como funciona o pré-lançamento imobiliário em Linhares?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'No pré-lançamento, o cliente reserva sua unidade com fluxo de pagamento flexível, aproveitando as melhores condições antes do lançamento oficial, seja para morar ou investir na localização que mais valoriza imóveis em Linhares.',
            },
          },
        ],
      },
    ];

    const existingScript = document.getElementById('schema-jsonld');
    if (existingScript) existingScript.remove();

    const script = document.createElement('script');
    script.id = 'schema-jsonld';
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById('schema-jsonld');
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <ApartmentFeatures />
      <PreLaunchTable />
      <Amenities />
      <LocationBenefits />
      <CallToAction />
      <Footer />
    </div>
  );
}
